import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import {
  getSentryHttpContext,
  sentryHttpExtras,
} from "./connectors/sentryAxiosInterceptor";

function captureWithContext(
  error: unknown,
  rqContext: { module: string; key: unknown },
): void {
  const httpCtx = getSentryHttpContext(error);

  Sentry.withScope((scope) => {
    scope.setTag("module", rqContext.module);
    scope.setExtra("queryKey", rqContext.key);
    if (httpCtx) {
      scope.setTag("http.status_code", httpCtx.status);
      scope.setTag("http.method", httpCtx.method);
      scope.setExtras(sentryHttpExtras(error));
    }
    Sentry.captureException(error);
  });
}

// Shared QueryClient so we can clear caches (e.g., on logout)
export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (query.state.fetchFailureCount !== query.options.retry) return;
      captureWithContext(error, {
        module: "react-query",
        key: query.queryKey,
      });
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _vars, _ctx, mutation) => {
      captureWithContext(error, {
        module: "react-query-mutation",
        key: mutation.options.mutationFn?.name ?? "anonymous",
      });
    },
  }),
});
